import axios from '@/config/httpConfig'

const modelName = "oss"

/**
 * 测试连接数据源
 * @param id
 * @returns {Promise<unknown>}
 */
export function connect(id) {
    return axios.get("/" + modelName + "/source/connect/" + id);
}

/**
 * 拉取数据库信息
 * @param id 数据源id
 * @returns {Promise<unknown>}
 */
export function pullDataBase(id) {
    return axios.get("/" + modelName + "/dataBase/pull/" + id);
}

/**
 * 拉取数据库表
 * @param id 数据库id
 */
export function pullDataTable(id) {
    return axios.get("/" + modelName + "/table/pull/" + id);
}

/**
 * 拉取数据字段表
 * @param id 数据表id
 */
export function pullDataField(id) {
    return axios.get("/" + modelName + "/field/pull/" + id);
}

/**
 * 执行sql语句（勾选表）
 * @param data 勾选表数据
 */
export function handleEachTable(data) {
    return axios.post("/" + modelName + "/dataBase/executeOfTable", data);
}

/**
 * 代码预览
 *
 * @param id
 * @returns {Promise | Promise<unknown>}
 */
export function codePreview(id) {
    return axios.get("/" + modelName + "/table/code/show/" + id);
}

/**
 * 创建菜单，模板生成代码后，添加路由菜单
 * @param id
 * @returns {Promise | Promise<unknown>}
 */
export function createMenu(id) {
    return axios.get("/" + modelName + "/table/menu/" + id)
}

/**
 * OSS文件管理相关API
 */

/**
 * 获取文件列表（分页）
 * @param data 查询参数
 * @returns {Promise<unknown>}
 */
export function getOssFilePage(data) {
    return axios.post("/" + modelName + "/file/page", data)
}

/**
 * 获取文件列表
 * @param data 查询参数
 * @returns {Promise<unknown>}
 */
export function getOssFileList(data) {
    return axios.get("/" + modelName + "/file/list", {
        params: data.param
    })
}

/**
 * 上传文件
 * @param formData 表单数据
 * @returns {Promise<unknown>}
 */
export function uploadOssFile(formData) {
    return axios.post("/" + modelName + "/file/upload", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 下载文件
 * @param objectKey 文件路径
 * @returns {Promise<unknown>}
 */
export function downloadOssFile(objectKey) {
    return axios.get("/" + modelName + "/file/download/" + objectKey, {
        responseType: 'blob'
    })
}

/**
 * 复制文件
 * @param data 复制参数
 * @returns {Promise<unknown>}
 */
export function copyOssFile(data) {
    return axios.post("/" + modelName + "/file/copy", data)
}

/**
 * 删除文件
 * @param objectKey 文件路径
 * @returns {Promise<unknown>}
 */
export function deleteOssFile(objectKey) {
    return axios.delete("/" + modelName + "/file/" + objectKey)
}

/**
 * 批量删除文件
 * @param objectKeys 文件路径列表
 * @returns {Promise<unknown>}
 */
export function deleteBatchOssFile(objectKeys) {
    return axios.delete("/" + modelName + "/file/batch", {
        data: objectKeys
    })
}

/**
 * 获取文件预签名URL
 * @param objectKey 文件路径
 * @param params 额外参数
 * @returns {Promise<unknown>}
 */
export function getOssFilePresignedUrl(objectKey, params) {
    return axios.get("/" + modelName + "/file/presigned-url/" + objectKey, params)
}

